import { topics } from '@/mocks/homepage';

export default function TopicsSection() {
  return (
    <section id="topics" className="relative py-16 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            当前最受关注的影视话题与热度趋势
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic, idx) => (
            <div
              key={topic.id}
              className={`group flex items-center gap-3 px-5 py-3 rounded-xl border transition-all duration-200 cursor-pointer ${
                idx < 3
                  ? 'bg-primary-500/8 border-primary-500/25 hover:bg-primary-500/15'
                  : 'bg-background-100 border-background-200/50 hover:border-background-300/60 hover:bg-background-200/50'
              }`}
            >
              {idx < 3 && (
                <span className={`w-6 h-6 flex items-center justify-center rounded-md text-xs font-bold ${
                  idx === 0 ? 'bg-accent-500 text-white' :
                  idx === 1 ? 'bg-primary-500 text-white' :
                  'bg-secondary-500 text-white'
                }`}>
                  {idx + 1}
                </span>
              )}
              <div className="text-left">
                <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{topic.name}</div>
                <div className="flex items-center gap-1.5 mt-0.5">
                  <span className="text-xs text-foreground-500">{topic.heat}热度</span>
                  {topic.trend === 'up' && <i className="ri-arrow-up-line text-xs text-accent-400"></i>}
                  {topic.trend === 'new' && <i className="ri-sparkling-line text-xs text-primary-400"></i>}
                  {topic.trend === 'stable' && <i className="ri-subtract-line text-xs text-foreground-500"></i>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}